import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import "./Inner.css";
import "./Eligibility.css";

const steps = [
  "Submitting your details",
  "Verifying your information",
  "Checking eligibility criteria",
  "Finalizing your result",
];

export default function EligibilityStatus() {
  const location = useLocation();
  const info = location.state || {};
  const [stepIndex, setStepIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (stepIndex < steps.length - 1) {
      const t = setTimeout(() => setStepIndex((i) => i + 1), 900);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setDone(true), 900);
    return () => clearTimeout(t);
  }, [stepIndex]);

  const progress = done ? 100 : Math.round(((stepIndex + 1) / steps.length) * 100);

  return (
    <>
      <section className="page-hero eligibility-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>Eligibility Check</span>
          <h1>Reviewing Your Details</h1>
        </div>
      </section>

      <section>
        <div className="container narrow">
          {!info.email && (
            <div className="notice">
              No details found — please start from the eligibility form.
            </div>
          )}

          <div className="progress-track">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>

          {!done ? (
            <p className="progress-label">{steps[stepIndex]}…</p>
          ) : (
            <>
              <p className="progress-label">Eligibility check complete.</p>
              <div className="notice">
                This is a demo screen. In production this result is returned by our
                partner eligibility service based on the email and phone number submitted.
              </div>
              <Link to="/contact" className="btn btn-primary" style={{ marginTop: "20px", display: "inline-block" }}>
                Book a Hearing Assessment
              </Link>
            </>
          )}
        </div>
      </section>
    </>
  );
}
